import { VERSION } from '../version';

type AboutProps = {
    onClose: () => void;
}

export function About(props: AboutProps) {
    return (
        <div className='about message'>
            <header>Waterfall Poker</header>
            <div>version {VERSION}</div>
            <div>&copy; {new Date().getFullYear()} JM Gustafson</div>
            <div>WorldTree Software</div>
            <div className='credit'>Card images courtesy of <a href="https://www.me.uk/cards" target="_blank" rel="noreferrer">Adrian Kennard</a></div>
            <button onClick={() => props.onClose()}>Close</button>
        </div>
    );
}
